import { Box, Typography, useTheme } from '@mui/material';

import { LEGEND_STATUSES, statusLabel, statusVisual } from '../statusTokens';

/**
 * Colour legend for the timesheet day squares/calendars.
 * Wraps on small screens; theme-aware (light/dark).
 */
const StatusLegend = ({ statuses = LEGEND_STATUSES, sx }) => {
    const { palette } = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 2,
                rowGap: 1,
                ...sx
            }}
        >
            {statuses.map((statusKey) => {
                const visual = statusVisual(palette, statusKey);
                return (
                    <Box
                        key={statusKey}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75
                        }}
                    >
                        <Box
                            sx={{
                                width: 12,
                                height: 12,
                                borderRadius: 0.5,
                                backgroundColor: visual.bg,
                                border: `1px solid ${palette.divider}`
                            }}
                        />
                        <Typography variant='caption' color='text.secondary'>
                            {statusLabel(statusKey)}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export { StatusLegend as default, StatusLegend };
